export class Auth{
    constructor(
        user_id: string = "",
        authenticated: boolean = false,
        access_token: string = "",
        created: Date = new Date(),
        expiration: Date = new Date()
      ){
        Auth.user_id = user_id;
        Auth.authenticated = authenticated;
        Auth.access_token = access_token;
        Auth.created = created;
        Auth.expiration = expiration;
      }

    static user_id: string;
    static authenticated: boolean;
    static access_token: string;
    static created: Date;
    static expiration: Date;
}